// Local storage utilities for anonymous user sessions

const STORAGE_KEYS = {
  USER_ID: 'taccounts_user_id',
  ACCOUNT_ID: 'taccounts_account_id',
};

const SESSION_CHANGED_EVENT = 'taccounts:anonymous-session-changed';

function emitSessionChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(SESSION_CHANGED_EVENT));
}

export const getAnonymousSession = () => {
  const userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
  const accountId = localStorage.getItem(STORAGE_KEYS.ACCOUNT_ID);
  
  if (userId && accountId) {
    return { userId, accountId };
  }
  return null;
};

export const setAnonymousSession = (userId, accountId) => {
  localStorage.setItem(STORAGE_KEYS.USER_ID, userId);
  localStorage.setItem(STORAGE_KEYS.ACCOUNT_ID, accountId);
  emitSessionChanged();
};

export const clearAnonymousSession = () => {
  localStorage.removeItem(STORAGE_KEYS.USER_ID);
  localStorage.removeItem(STORAGE_KEYS.ACCOUNT_ID);
  emitSessionChanged();
};

export const hasAnonymousSession = () => {
  return !!getAnonymousSession();
};

export const ANONYMOUS_SESSION_CHANGED_EVENT = SESSION_CHANGED_EVENT;
